import { useState } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { SendPasswordResetEmail } from '../../utils/FirebaseUtils.ts'

export default function ForgotPasswordPopUp({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const [emailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState('')

  const handlePasswordReset = async () => {
    // TODO: validateEmail
    await SendPasswordResetEmail(email)
    setEmailSent(true)
  }

  const closePopUp = () => {
    onClose()
    //Prevent flickering
    setTimeout(() => {
      setEmailSent(false)
    }, 300)
  }

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95">
            <div>
              {emailSent && (
                <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                  <CheckIcon
                    aria-hidden="true"
                    className="size-6 text-green-600"
                  />
                </div>
              )}
              <div className="mt-3 text-center sm:mt-5">
                {!emailSent && (
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold text-gray-900">
                    Forgot Password
                  </DialogTitle>
                )}
                {emailSent && (
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold text-gray-900">
                    Email sent
                  </DialogTitle>
                )}
                {!emailSent && (
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Enter your email and we'll send you a link to reset your
                      password
                    </p>
                  </div>
                )}
                {emailSent && (
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      If this email is registered, we’ve sent a link to reset
                      your password. Please check your inbox to continue
                    </p>
                  </div>
                )}
                {!emailSent && (
                  <div className="mt-6 flex">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      name="email"
                      type="email"
                      placeholder="Enter an email"
                      aria-label="Email address"
                      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    />
                  </div>
                )}
              </div>
            </div>
            {!emailSent && (
              <div className="mt-5 sm:mt-6">
                <button
                  type="button"
                  onClick={handlePasswordReset}
                  className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  Send link to email
                </button>
              </div>
            )}
            {emailSent && (
              <div className="mt-5 sm:mt-6">
                <button
                  type="button"
                  onClick={closePopUp}
                  className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  Go back to login page
                </button>
              </div>
            )}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
